import React from 'react';
// import { motion } from 'framer-motion';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  return (
    <div className="min-h-screen bg-white pt-16">
      <section className="pt-20 pb-16 bg-gradient-to-br from-black-900 to-black-800 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-6xl font-bold text-center">Disclaimer</h1>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose lg:prose-xl">
            <p>
              The information provided on this website is for educational purposes only and is not intended as financial or career advice.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
  */
};

export default Disclaimer;